<template>
    <div class="m-friend">
        <h5 class="title"></h5>
        <div class="slogen"></div>
        <div class="page-detail">
            <div class="user-info">
                <div class="user-data">
                    <div class="total">返利用户累计<span>{{ cnt }}人</span></div>
                    <div class="total-score">
                        <div class="cnt">可获返利累计<em class="i-m3b"></em><span>{{ score }}</span></div>
                        <div class="u-btn reflash" @click="call_reflash()"></div>
                    </div>
                </div>


                <div class="u-btn rule" @click="$rule_modal()"></div>
            </div>

            <div class="data-table">
                <div class="table-view">
                    <vuescroll v-if="friend_list.length">
                        <table>
                            <tbody>
                                <tr v-for="(item,index) in friend_list" :key="index">
                                    <td class="tag"><div class="index">{{ (index+1) }}</div></td>
                                    <td class="name">{{ item.nickName }}</td>
                                    <td class="flag">
                                        <div class="icon-yes" v-if="item.isAd"></div>
                                        <div class="icon-no" v-else></div>
                                    </td>
                                    <td>{{ item.payM3b }}</td>                                    
                                </tr>
                            </tbody>
                        </table>
                    </vuescroll>

                    <div class="empty" v-else></div>
                </div>

            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@mixin boxStyle ( $screenWidth ){

    .title{
        margin: 0 auto;

        @if ( $screenWidth == 1600) {
            width: 939px;
            height: 148px;
            background-image: url(~@/assets/images/pc/title-4.png);
        }@else if( $screenWidth == 1000 ) {
            width: 750px;
            height: 148px;
            background-image: url(~@/assets/images/m/title-4.png);
        }         
    }

    .user-info{
        display: flex;
        justify-content: space-between;
        position: relative;

        .user-data{
            position: relative;
            display: flex;
        }

        @if ( $screenWidth == 1600) {

            .total{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 235px;
                height: 37px;
                text-align: center;
                margin-right: 20px;
                font-size: 16px;
                color: #2b2824;
                background-image: url(~@/assets/images/pc/bg-total.png);

                span{
                    padding-left: 10px;
                    font-size: 24px;
                    color: #b43b33;
                }
            }

            .total-score{
                position: relative;
                width: 353px;
                height: 37px;
                line-height: 37px;
                background-image: url(~@/assets/images/pc/bg-score.png); 
                
                .cnt{
                    display: flex;
                    align-items: center;
                    padding-left: 40px;
                    font-size: 16px;
                    color: #2b2824;
                    
                    .i-m3b{
                        display: block;
                        width: 39px;
                        height: 38px;
                        margin: 0 5px;
                        background-image: url(~@/assets/images/pc/icon-m3b.png); 
                    }
                    
                    span{
                        padding-left: 10px;
                        font-size: 24px;
                        color: #b43b33;
                    }                    
                }
            }

            .u-btn.reflash{
                position: absolute;
                right: 30px;
                top: 50%;
                transform: translateY(-50%);
                width: 40px;
                height: 39px;
                background-image: url(~@/assets/images/pc/btn-reflash.png);    
            }

            .u-btn.rule{
                width: 149px;
                height: 36px;
                background-image: url(~@/assets/images/pc/btn-rule.png);
                
                &:hover{
                    background-image: url(~@/assets/images/pc/btn-rule_hover.png);
                }
            }

        }@else if( $screenWidth == 1000 ) {

            padding-top: 85px;

            .user-data{
                width: 710px;
                margin: 0 auto;
                justify-content: space-between;
            }
            .total{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 285px;
                height: 47px;
                text-align: center;
                margin-right: 20px;
                font-size: 24px;
                color: #2b2824;
                background-image: url(~@/assets/images/m/bg-total.png);

                span{
                    padding-left: 10px;
                    font-size: 24px;
                    color: #b43b33;
                }
            }

            .total-score{
                position: relative;
                width: 393px;
                height: 47px;
                line-height: 47px;
                background-image: url(~@/assets/images/m/bg-score.png); 
                
                .cnt{
                    display: flex;
                    align-items: center;
                    padding-left: 40px;
                    font-size: 24px;
                    color: #2b2824;
                    
                    .i-m3b{
                        display: block;
                        width: 39px;
                        height: 38px;
                        margin: 0 5px;
                        background-image: url(~@/assets/images/pc/icon-m3b.png); 
                    }
                    
                    span{
                        padding-left: 10px;
                        font-size: 24px;
                        color: #b43b33;
                    }                    
                }
            }

            .u-btn.reflash{
                position: absolute;
                right: 30px;
                top: 50%;
                transform: translateY(-50%);
                width: 40px;
                height: 39px;
                background-image: url(~@/assets/images/pc/btn-reflash.png);    
            }

            .u-btn.rule{
                position: absolute;
                top: 0;
                left: 50%;
                transform: translateX(-50%);
                width: 225px;
                height: 54px;
                background-image: url(~@/assets/images/m/btn-rule.png);
            }
        }           

    }

    .data-table{
        margin: 0 auto;
        @if ( $screenWidth == 1600) {
            width: 1201px;
            height: 510px;
            margin-top: 15px;
            background-image: url(~@/assets/images/pc/table-pannel.png);

            .table-view{
                position: relative;
                padding-top: 78px;
                width: 1180px;
                height: 405px;

                .empty{
                    position: absolute;
                    top: 140px;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 225px;
                    height: 308px;
                    background-image: url(~@/assets/images/pc/empty.png);
                }
            }

            table{
                width: 1100px;
                text-align: center;

                tr{
                    height: 36px;

                    .tag{
                        width: 244px;
                    }

                    .name{
                        width: 250px;
                    }

                    .flag{
                        width: 320px;
                    }
                }

                .index{
                    width: 30px;
                    height: 30px;
                    margin: 0 auto;
                    line-height: 30px;
                    font-size: 14px;
                    text-align: center;
                    color: #fff;
                    background-image: url(~@/assets/images/pc/bg-index.png);
                }

                .icon-yes{
                    width: 31px;
                    height: 29px;
                    margin: 0 auto;
                    background-image: url(~@/assets/images/pc/icon-yes.png);                    
                }

                .icon-no{
                    width: 31px;
                    height: 30px;
                    margin: 0 auto;
                    background-image: url(~@/assets/images/pc/icon-no.png);                    
                }                
            }

        }@else if( $screenWidth == 1000 ) {
            width: 710px;
            height: 690px;
            margin-top: 15px;
            background-image: url(~@/assets/images/m/table-pannel.png);

            .table-view{
                position: relative;
                padding-top: 78px;
                width: 695px;
                height: 650px;

                .empty{
                    position: absolute;
                    top:160px;
                    left: 50%;
                    transform: translateX(-50%);
                    margin-left: 40px;
                    width: 293px;
                    height: 400px;
                    background-image: url(~@/assets/images/m/empty.png);
                }                
            }

            table{
                width: 680px;
                text-align: center;

                tr{
                    height: 52px;

                    .tag{
                        width: 100px;
                    }

                    .name{
                        width: 200px;
                    }

                    .flag{
                        width: 200px;
                    }

                }

                .index{
                    width: 48px;
                    height: 48px;
                    margin: 0 auto;
                    line-height: 48px;
                    text-align: center;
                    color: #fff;
                    background-image: url(~@/assets/images/m/bg-index.png);
                    background-size: 100% 100%;
                }

                .icon-yes{
                    width: 46px;
                    height: 44px;
                    margin: 0 auto;
                    background-image: url(~@/assets/images/m/icon-yes.png);                    
                }

                .icon-no{
                    width: 46px;
                    height: 44px;
                    margin: 0 auto;
                    background-image: url(~@/assets/images/m/icon-no.png);                    
                }                
            }
        }           
    }


    @if ( $screenWidth == 1600) {

    }@else if( $screenWidth == 1000 ) {

    }    

}

@media screen and (min-width: 1000px){
@include boxStyle( 1600 );
}
@media screen and (min-width: 375px) and (max-width: 999px){
@include boxStyle( 1000 );
}
</style>

<script>
export default {
    data (){
        return {
            friend_list : [],
            cnt : 0,
            score : 0
        }
    },
    mounted(){
        this.render();
    },
    methods : {
        render (type){
            this.$get(ajax_url_map.friend_list,{
                success : (data) => {
                    this.friend_list = data.data.list;
                    this.cnt = data.data.count;
                    this.score = data.data.totalAdM3b;

                    if(type)this.$toast('刷新成功~');
                },
                error : () => {},
            })
        },
        call_reflash(){
            if(!this.$store.state.login){
                return this.$mslogin.open();
            }
            if(!this.$store.state.userinfo.areaId){
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }
            
            this.render(1);
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/views/friend.vue